import { render, staticRenderFns } from "./AlertPhoneNumbers.vue?vue&type=template&id=5c98c7d8&lang=pug&"
import script from "./AlertPhoneNumbers.vue?vue&type=script&lang=ts&"
export * from "./AlertPhoneNumbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports